package com.sweetlime.bingeamigo.presentation.features.home

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.sweetlime.bingeamigo.model.Episode
import com.sweetlime.bingeamigo.model.Movie
import com.sweetlime.bingeamigo.model.TvShow
import com.sweetlime.bingeamigo.presentation.features.moviedetail.MovieDetailScreen
import com.sweetlime.bingeamigo.presentation.features.notifications.NotificationsScreen
import com.sweetlime.bingeamigo.presentation.features.tvdetail.EpisodeDetailScreen
import com.sweetlime.bingeamigo.presentation.features.tvdetail.TvShowDetailScreen
import org.koin.compose.viewmodel.koinViewModel

class HomeScreen(
    private val onNavigateToSearch: () -> Unit,
    private val onNavigateToProfile: () -> Unit = {}
) : Screen {

    @Composable
    override fun Content() {
        val navigator = LocalNavigator.currentOrThrow
        val viewModel = koinViewModel<HomeViewModel>()

        val uiState by viewModel.uiState.collectAsStateWithLifecycle()

        HomeContent(
            uiState = uiState,
            onMovieClick = { movie ->
                navigator.push(MovieDetailScreen(movie))
            },
            onTvShowClick = { tvShow ->
                navigator.push(TvShowDetailScreen(tvShow))
            },
            onMarkNextEpisodeWatched = { tvShowId -> viewModel.markNextEpisodeWatched(tvShowId) },
            onNavigateToSearch = onNavigateToSearch,
            onProfileClick = onNavigateToProfile,
            onNotificationsClick = { navigator.push(NotificationsScreen) },
            onActivityClick = { activity ->
                val tvShow = if (activity.tvShowId != 0) TvShow(
                    id = activity.tvShowId, name = activity.tvShowTitle, overview = "", posterPath = activity.tvShowPoster
                ) else null
                when {
                    activity.episodeId != 0 && tvShow != null -> navigator.push(EpisodeDetailScreen(
                        tvShow = tvShow,
                        episode = Episode(id = activity.episodeId, name = activity.episodeName, episodeNumber = activity.episodeNumber, seasonNumber = activity.seasonNumber, stillPath = activity.episodeStillPath.ifEmpty { null }),
                        totalEpisodesInShow = 0
                    ))
                    tvShow != null -> navigator.push(TvShowDetailScreen(tvShow))
                    else -> navigator.push(MovieDetailScreen(Movie(
                        id = activity.movieId, title = activity.movieTitle, overview = "", posterPath = activity.moviePoster
                    )))
                }
            }
        )
    }
}
